module.exports = __webpack_public_path__ + "media/packs/images/flags/FJ-eaf768d9937298a0aa7008b6a75c7706.png";